import { Location } from 'react-router-dom';

export type AbsenteeBidSlice = {
    bidAmount: number | null;
    bidPlaced: boolean;
    error: boolean;
    errorMessage?: string;
    isCurrentHighBid: boolean;
    itemId: number | null;
    submitted: boolean;
    success: boolean;
    suggestedBidFloor?: number;
};

export const defaultAbsenteeBidSlice: AbsenteeBidSlice = {
    bidAmount: null,
    bidPlaced: false,
    error: false,
    errorMessage: undefined,
    isCurrentHighBid: false,
    itemId: null,
    submitted: false,
    success: false,
    suggestedBidFloor: 0,
};

export type AbsenteeBidDetails = {
    bidAmount: number;
    catalogId: number;
    client?: 'React';
    deviceType?: 'Mobile' | 'Desktop';
    itemId: number;
    raisedAbsenteeBid?: boolean;
};

export type SubmitAbsenteeBidParams = {
    absenteeBidDetails: AbsenteeBidDetails;
    location: Location;
};

/**
 * @category Mainhost API
 * @see postPlaceAbsenteeBid
 */
export type PostPlaceAbsenteeBidParams = {
    authToken: string;
    deployment: string;
    details: AbsenteeBidDetails;
};

export type PostPlaceAbsenteeBidApiResponse = {
    current_bid: string;
    is_current_high_bid: boolean;
    is_reserve_met: boolean;
    leading_bid: string;
    message: string;
    success: boolean;
    suggestedBidFloor: string;
};

export type PostPlaceAbsenteeBidResponse = {
    currentBid: number;
    isCurrentHighBid: boolean;
    isReserveMet: boolean;
    leadingBid: number;
    message: string;
    success: boolean;
    suggestedBidFloor?: number;
};

export type SubmitAbsenteeBidPayload = {
    meta: {
        actionTime: number;
        analytics: any;
        itemId: number;
    };
    payload: PostPlaceAbsenteeBidResponse;
};
